//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import Translated from '~/components/legacy/global/translated'

export default {
  name: 'ProductPanel',

  components: {
    Translated
  },

  props: {
    products: {
      type: Array,
      default: () => []
    },

    initialActiveVariantSku: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      activeVariantIndex: 0
    }
  },

  fetch () {
    // If we've been passed an initial active variant SKU then determine and override the activeVariantIndex
    if (this.initialActiveVariantSku) {
      const index = this.products.findIndex(product => product.sku === this.initialActiveVariantSku)
      if (Number.isInteger(index)) this.activeVariantIndex = index
    }
  },

  computed: {
    ...mapGetters({
      getQueryFromSku: 'bundle/getQueryFromSku',
      getProductName: 'product/productName'
    }),
    activeVariant () {
      return this.products[this.activeVariantIndex]
    },
    reviewsSummary () {
      if (!this.activeVariant?.sku) return {}
      return this.$store.getters['review/productSummary'](this.activeVariant.sku) || {}
    },
    promo () {
      return this.activeVariant.promo || {}
    },
    discount () {
      if (!this.promo.value) return 0
      return this.promo.value
    },
    discountedPrice () {
      return this.activeVariant.price * (1 - this.discount)
    }
  },

  watch: {
    activeVariantIndex () {
      this.$emit('change-variant', this.activeVariant)
      this.trackProductView()
    }
  },

  mounted () {
    this.trackProductView()
  },

  methods: {
    async addToBasket () {
      try {
        const success = await this.$store.dispatch('cart/ADD_TO_CART', [
          this.getQueryFromSku(this.activeVariant.sku),
          this.activeVariant.sku
        ])

        if (success) {
          this.$store.commit('cart/SET_SKIP_FETCH_CART_STATE', true)
          this.$redirect('/checkout/cart/')
        }
      } catch (error) {
        this.$sentry.captureException(error, { action: 'addToBasket', location: 'ProductPanel' })
        this.$store.commit('cart/ADD_ERROR_MESSAGE', { body: 'Unable to add to basket. Please try again.' })
      }
    },
    trackProductView () {
      this.$track.ecommerce.viewProductPage([{ sku: this.activeVariant.sku }])
    }
  }
}
